// extracted by mini-css-extract-plugin
module.exports = {"account-title":"Title_account-title__iRlMk","accountTitle":"Title_account-title__iRlMk"};